import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    '& > span': {
      margin: theme.spacing(2),
    },
  },
}));

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  },
}))(Tooltip);

function IconHead(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HtmlTooltip placement="top" title={
         <React.Fragment>
           <Typography color="inherit">{props.title}</Typography>
           {props.body}
         </React.Fragment>
        }>
        <Icon style={{cursor: "grab"}}>info</Icon>
      </HtmlTooltip>
    </div>
  );
};

export default IconHead;
